import { GlobalAxios } from "../axios/axios-config";
import { IEsignEnvelopeEmailSend } from "../models/esign-envelope-email-send";

const ESIGN_ENVELOPE_EMAIL_SEND_ROUTE =
  process.env.REACT_APP_4UESIGN + "/api/v1/EsignEnvelopeEmailSend";

export const getEsignEnvelopeEmailSend = (
  documentCode: string,
  firstIntegrationId: string,
) => {
  return GlobalAxios.get<IEsignEnvelopeEmailSend>(
    ESIGN_ENVELOPE_EMAIL_SEND_ROUTE,
    {
      params: {
        documentCode,
        patientEncounterNumber: firstIntegrationId,
      },
    },
  );
};
